
    import {
        defineComponent,
        onMounted,
        createVNode,
        reactive,
        ref
    } from 'vue';
    import {
        ReloadOutlined,
        PlusOutlined,
        InboxOutlined
    } from '@ant-design/icons-vue';
    import addPeople from "./addPeople.vue"
    import {
        Modal,
        message
    } from 'ant-design-vue';
    import taskreviewer from '@/service/taskreviewer'
    import {baseUrl} from '@/config'

    export default defineComponent({
        components: {
            ReloadOutlined,
            PlusOutlined,
            InboxOutlined,
            addPeople
        },
        props: {
            taskId: String,
            taskName: String,
            taskStatus: String,
            ifAllot: String,
            identity: String // //0普通评审 1仲裁评审
        },
        setup(props, context) {
            // 声明
            let searchName = ref("")
            const openPop = ref();
            let fileList = ref([]);
            let batchVisible = ref(false);
            let value = ref(undefined)
            let states = reactive({
                errorList: [{}]
            });
            // 页面渲染时加载
            onMounted(() => {
            })
            // 搜索查询
            const onSearch = () => {
                let searchData = {
                    searchValue: searchName.value,
                }
                context.emit("search", searchData);
            };
            // 刷新
            const refresh = () => {
                context.emit("refresh", "ok");
            }
            // 添加人员
            const add = () => {
                openPop.value.open(props.taskId, props.taskName, props.identity);
            }
            // 导入人员
            const batchAdd = () => {
                states.errorList = [];
                fileList.value = [];
                batchVisible.value = true;
            }
            // 对上传的excel进行移除
            const handleRemove = file => {
                states.errorList = [];
                const index = fileList.value.indexOf(file);
                const newFileList = fileList.value.slice();
                newFileList.splice(index, 1);
                fileList.value = newFileList;
            };
            // 上传excel
            const beforeUpload = file => {
                states.errorList = [];
                fileList.value = [];
                if(fileList.value == ''){
                    fileList.value = [...fileList.value, file];
                }else{
                    message.warning('导入文件只能上传一个');
                }
                return false;
            };
            // 确认批量添加
            const batchOk = () => {
                if(fileList.value == ''){
                    message.warning('请上传要导入的文件');
                    return ;
                }
                taskreviewer.saveUploadFile(sessionStorage.getItem('schoolCode'), props.taskId, props.taskName, fileList.value[0], props.identity).then(({data}) => {
					
					if (data.code == '0') {
                        message.success(data.msg);
                        states.errorList = [];
                        fileList.value = [];
                        batchVisible.value = false;
                        context.emit("refresh", "ok");
                    } else {
						states.errorList =data.data;
                        message.error(data.msg);
						
                    }
                })
            }
            //导出信息
            const batchExport = () => {
                Modal.confirm({
                    title: '确定要导出查询的评审人员吗？',
                    content: createVNode('div', {
                        style: 'color:red;',
                    }, ''),
                    cancelText: '取消',
                    okText: '确认',
                    onOk() {
                        taskreviewer.exportAlloca( sessionStorage.getItem('schoolCode'), props.taskId, props.identity ).then(({data}) => {
                            if (data.code == '0') {
                                message.success('操作成功');
                                let urlRechitr = baseUrl + data.url;
                                window.open( urlRechitr, '_blank');
                            } else {
                                message.error(data.msg);
                            }
                        })
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });
            }
            //分配评审
            const batchAllocation = () => {
                Modal.confirm({
                    title: '确认要分配审批吗? 分配审批后不可新增、删除评审人员',
                    content: createVNode('div', {
                        style: 'color:red;',
                    }, ''),
                    cancelText: '取消',
                    okText: '确认',
                    onOk() {
                        if(props.identity == '0'){
                            taskreviewer.allotReview(sessionStorage.getItem('schoolCode'), props.taskId).then(({data}) => {
                                if (data.code == '0') {
                                    context.emit("closeRefresh", "ok");
                                    message.success('操作成功');
                                } else {
                                    message.error(data.msg);
                                }
                            })
                        }else{
                            taskreviewer.allotArbitration(sessionStorage.getItem('schoolCode'), props.taskId).then(({data}) => {
                                if (data.code == '0') {
                                    context.emit("closeRefresh", "ok");
                                    message.success('操作成功');
									
                                } else {
                                    message.error(data.msg);
                                }
                            })
                        }
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });
            }
           
			return {
                refresh,
                value,
                searchName,
                onSearch,
                openPop,
                add,
                batchAdd,
                batchExport,
                batchAllocation,
                handleRemove,
                beforeUpload,
                batchOk,
                batchVisible,
                states,
				fileList
            };
        },

    });
